"use client";

import { useState } from "react";

type EmailProps = {
  itinerary: string;
  city: string;
  itinid: string;
};

export default function Email({ itinerary, city, itinid }: EmailProps) {
  const initialState = "Email Itinerary";
  const [buttonText, setButtonText] = useState(initialState);
  const [isSending, setIsSending] = useState(false);

  const changeText = (text: string) => {
    setButtonText(text);
    setTimeout(() => setButtonText(initialState), 2500);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isSending) return;

    const form = event.target as HTMLFormElement;
    const emailElement = form.elements.namedItem(
      "emailaddress"
    ) as HTMLInputElement;
    const emailValue = emailElement.value;

    // Track the event
    try {
      // @ts-expect-error - gtag might not be defined in TypeScript
      window.gtag?.("event", "btn_click_email", {
        event_category: "button_click",
        event_label: emailValue,
        value: 1,
      });
    } catch (error) {
      console.error("Error tracking event:", error);
    }

    const ITINERARY_URL = `https://www.aitripmaker.com/show/${city}${
      itinid !== "DEFAULT" ? `/${itinid}` : ""
    }`;
    const TEXT_TO_APPEND = `\n\nAccess Itinerary Here: ${ITINERARY_URL}\n\nGenerated By: aitripmaker.com \n`;

    setIsSending(true);
    try {
      const res = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          itinerary:
            itinerary.replace("display:flex", "display:block") +
            TEXT_TO_APPEND,
          emailaddress: emailValue,
          htmlitinerary: `
            <div>
              ${itinerary.replace("display:flex", "display:block")}
              <br>
              Access Itinerary Here: <a href="${ITINERARY_URL}" target="_blank" rel="noopener noreferrer">${ITINERARY_URL}</a>
              <br>
              Generated By: <a href="https://www.aitripmaker.com" target="_blank" rel="noopener noreferrer">aitripmaker.com</a>
              <br>
            </div>
          `,
        }),
      });

      const data = await res.json().catch(() => null);

      if (res.ok && data?.success) {
        changeText("Email Sent ✓");
      } else {
        changeText(data?.error || "Failed, try again");
      }
    } catch (error) {
      console.error(error);
      changeText("Failed, try again");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <form
      name="emailForm"
      id="emailFormID"
      className="flex flex-col gap-4 sm:flex-row w-full"
      onSubmit={handleSubmit}
    >
      <input
        type="email"
        required
        name="emailaddress"
        id="emailaddress"
        placeholder="Email Address"
        className="flex-grow px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent "
      />
      <button
        id="emailSubmitButton"
        type="submit"
        disabled={isSending}
        className={`px-4 py-2 rounded-md font-medium transition-all hover:cursor-pointer bg-gradient-to-r from-orange-500 to-amber-400 hover:from-orange-600 hover:to-amber-500 text-white sm:mt-0 mt-2 shadow-md hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed`}
      >
        {isSending ? "Sending..." : buttonText}
      </button>
    </form>
  );
}
